// @file Store for user experiments
import { MakePageSimplifiedLayoutExperimentVariant, SelfServeFreeTrialExperimentVariant } from '@@/enums'
import { defineStore } from 'pinia'
import { ref } from 'vue'

enum UpgradeModalCopyAExperimentVariant {
  Control = 'control',
  Variation = 'variation',
}

enum UpgradeModalSingleStepExperimentVariant {
  Control = 'control',
  Variation = 'variation',
}

const useExperimentsStore = defineStore('experiments', () => {
  // State
  /**
   * Experiment: `upgrade_modal_copy_a`
   */
  const upgradeModalCopyAExperimentVariant = ref<UpgradeModalCopyAExperimentVariant>(
    UpgradeModalCopyAExperimentVariant.Control,
  )

  const upgradeModalSingleStepExperimentVariant = ref<UpgradeModalSingleStepExperimentVariant>(
    UpgradeModalSingleStepExperimentVariant.Control,
  )

  const setUpgradeModalCopyAExperimentVariant = (
    upgradeModalCopyAExperimentVariantValue: UpgradeModalCopyAExperimentVariant | undefined,
  ): void => {
    upgradeModalCopyAExperimentVariant.value =
      upgradeModalCopyAExperimentVariantValue ?? UpgradeModalCopyAExperimentVariant.Control
  }

  const setUpgradeModalSingleStepExperimentVariant = (
    upgradeModalSingleStepExperimentVariantValue: UpgradeModalSingleStepExperimentVariant | undefined,
  ): void => {
    upgradeModalSingleStepExperimentVariant.value =
      upgradeModalSingleStepExperimentVariantValue ?? UpgradeModalSingleStepExperimentVariant.Control
  }

  /**
   * Experiment: `make_page_simplified_layout_experiment`
   */
  const makePageSimplifiedLayoutExperimentVariant = ref<MakePageSimplifiedLayoutExperimentVariant>(
    MakePageSimplifiedLayoutExperimentVariant.Control,
  )

  const setMakePageSimplifiedLayoutExperimentVariant = (
    makePageSimplifiedLayoutExperimentVariantValue: MakePageSimplifiedLayoutExperimentVariant | undefined,
  ): void => {
    makePageSimplifiedLayoutExperimentVariant.value =
      makePageSimplifiedLayoutExperimentVariantValue ?? MakePageSimplifiedLayoutExperimentVariant.Control
  }

  /**
   * Experiment: `self_serve_free_trial_experiment`
   */
  const selfServeFreeTrialExperimentVariant = ref<SelfServeFreeTrialExperimentVariant>(
    SelfServeFreeTrialExperimentVariant.Control,
  )

  const setSelfServeFreeTrialExperimentVariant = (
    selfServeFreeTrialExperimentVariantValue: SelfServeFreeTrialExperimentVariant | undefined,
  ): void => {
    selfServeFreeTrialExperimentVariant.value =
      selfServeFreeTrialExperimentVariantValue ?? SelfServeFreeTrialExperimentVariant.Control
  }

  return {
    // State
    upgradeModalCopyAExperimentVariant,
    upgradeModalSingleStepExperimentVariant,
    makePageSimplifiedLayoutExperimentVariant,
    selfServeFreeTrialExperimentVariant,

    // Action
    setUpgradeModalCopyAExperimentVariant,
    setUpgradeModalSingleStepExperimentVariant,
    setMakePageSimplifiedLayoutExperimentVariant,
    setSelfServeFreeTrialExperimentVariant,
  }
})
export { UpgradeModalCopyAExperimentVariant, UpgradeModalSingleStepExperimentVariant, useExperimentsStore }
